import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentConsultation from "@/pages/DepressionTreatmentConsultation";
export const Route = createFileRoute("/depression-treatment-consultation")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Consultation | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What to expect at a depression treatment consultation in Coral Springs, FL. Learn what questions to ask and how to prepare for your first visit.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Consultation | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What to expect at a depression treatment consultation in Coral Springs, FL. Learn what questions to ask and how to prepare for your first visit.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-treatment-consultation",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-consultation",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentConsultation />;
}
